import React, { useEffect, useRef, useState } from "react";
import LoadingBar from "react-top-loading-bar";

import PageLayout from "../../layout/PageLayout/pageLayout";
import noRecord from "../../include/images/nrb-img.svg";
import search from "../../include/images/search.svg";
import backward from "../../include/images/backward.svg";
import forward from "../../include/images/forward.svg";
import { connect } from "react-redux";
import { getUserStories, userStoryData } from "../../store/userStory";
import { toast } from "react-toastify";
import AlertError from "../../common/alerts/alertError";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import { capitalizeFirstLetterWord, getRelativeTime } from "../../utils/helperFunctions";
import Skeleton from "react-loading-skeleton";

const CustomerStory = (props) => {
  const ref = useRef();
  const storyData = props?.userStoryData?.stories?.data || [];

  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState("1");
  const [searchKeyword, setSearchKeyword] = useState("");

  const getStory = () => {
    setLoading(true);
    ref?.current?.continuousStart();
    props?.getUserStories(
      {
        order: "desc",
        limit: 52,
        page,
        keyword: searchKeyword?.replace(/[^a-zA-Z0-9 ]+/g, ""),
      },
      (res) => {
        ref?.current?.complete();
        setLoading(false);
        if (res?.status != 200) {
          toast(<AlertError message={res?.data?.message || "Something went wrong!!"} />);
        }
      },
    );
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    getStory();
  }, [page, searchKeyword]);

  const totalCount = props?.userStoryData?.stories?.totalCount || 0;
  const dataPerPage = props?.userStoryData?.stories?.recordsPerPage || 0;
  const filteredCount = props?.userStoryData?.stories?.filteredCount || 0;
  const noOfPage = Math.ceil(totalCount / filteredCount) || 0;
  const currentPage = page || 1;

  const start = totalCount === 0 ? 0 : (currentPage - 1) * dataPerPage + 1;
  const end = Math.min(currentPage * dataPerPage, totalCount);

  return (
    <>
      <LoadingBar height={5} color="#47AD1D" ref={ref} />
      <PageLayout>
        <div class="content-container story-list-container">
          <div class="container">
            <div class="row">
              <div class="col-md-12">
                <div class="breadcrumb-row d-flex flex-wrap mb-4">
                  <div class="breadcrumb-box">
                    <Link to="/">Home</Link>
                  </div>
                  <div class="breadcrumb-box">
                    <a href="javascript:void(0)">Stories</a>
                  </div>
                </div>
                <div class="sl-title-row d-flex justify-content-between align-items-center mb-4">
                  <div class="sl-t-left">
                    <h1>Stories</h1>
                  </div>
                </div>
                <div class="sl-tab-container">
                  <div class="accordion tab-content" id="accordionExample">
                    <div
                      class="tab-pane fade show active"
                      id="tab1-pane"
                      role="tabpanel"
                      aria-labelledby="tab1"
                      tabindex="0"
                    >
                      <div id="collapseOne" class="accordion-collapse collapse show" data-bs-parent="#accordionExample">
                        <div class="story-filters-row d-flex flex-column flex-lg-row align-items-lg-center justify-content-lg-between gap-3 gap-lg-2">
                          <div class="story-filters-search">
                            <div class="page-search-block">
                              <button type="button">
                                <img src={search} alt="" />
                              </button>
                              <input
                                type="search"
                                class="form-control"
                                placeholder="Search"
                                onChange={(e) => setSearchKeyword(e.target.value)}
                                value={searchKeyword}
                              />
                            </div>
                          </div>
                        </div>
                        <div class="story-table ss-table-height">
                          <div class="table-responsive">
                            <table class="table filter-story-table ss-filter-story-table ss-table-height">
                              <thead>
                                <tr>
                                  <th style={{ width: "10%" }}>Photos</th>
                                  <th style={{ width: "35%" }}>Title</th>
                                  <th style={{ width: "20%" }}>Contributor</th>
                                  <th style={{ width: "15%" }}>Category</th>

                                  <th style={{ width: "30%" }}>Animal</th>
                                </tr>
                              </thead>
                              <tbody>
                                {loading ? (
                                  [1, 2, 3, 4, 5, 6]?.map((item) => (
                                    <tr>
                                      <td style={{ width: "10%" }}>
                                        <Skeleton />
                                      </td>
                                      <td style={{ width: "35%" }}>
                                        <Skeleton />
                                      </td>
                                      <td style={{ width: "20%" }}>
                                        <Skeleton />
                                      </td>
                                      <td style={{ width: "15%" }}>
                                        <Skeleton />
                                      </td>
                                      <td style={{ width: "30%" }}>
                                        <Skeleton />
                                      </td>
                                    </tr>
                                  ))
                                ) : storyData?.length > 0 ? (
                                  storyData?.map((item) => (
                                    <tr>
                                      <td>
                                        <Link to={`/user-story/${item?.slug}`} class="photo-wrap">
                                          <img
                                            className="ss-story-img"
                                            src={process.env.REACT_APP_MEDIA + item?.featuredImage[0]?.original}
                                            alt=""
                                          />
                                        </Link>
                                      </td>
                                      <td>
                                        <Link to={{ pathname: `/user-story/${item?.slug}` }} class="story-title">
                                          {item?.title}
                                        </Link>
                                      </td>
                                      <td>
                                        <div class="author-detail d-flex">
                                          <div class="author-img">
                                            <img
                                              src={
                                                process.env.REACT_APP_MEDIA + item?.createdBy?.profilePicture?.original
                                              }
                                              alt=""
                                            />
                                          </div>
                                          <div class="author-text">
                                            <h3>
                                              {item?.contributor?.length > 50
                                                ? item?.contributor?.slice(0, 50) + "..."
                                                : item?.contributor}
                                            </h3>
                                          </div>
                                        </div>
                                      </td>
                                      <td>
                                        {Array.from(
                                          new Set(
                                            item?.species?.map((iu) =>
                                              capitalizeFirstLetterWord(iu?.speciesCategoryName),
                                            ),
                                          ),
                                        ).join(", ")}
                                      </td>
                                      <td>
                                        {[...new Map(item?.species?.map((s) => [s.slug, s])).values()].map(
                                          (it, index, arr) => (
                                            <React.Fragment key={it.slug}>
                                              <Link to={`/endangered-species/${it.slug}`}>
                                                {capitalizeFirstLetterWord(it.displayCommonName)}
                                              </Link>
                                              {index < arr.length - 1 && ", "}
                                            </React.Fragment>
                                          ),
                                        )}
                                      </td>
                                    </tr>
                                  ))
                                ) : (
                                  <tr style={{ minHeight: "200px", height: "200px" }}>
                                    <td colSpan={"6"} className="empty-td ">
                                      <div className="d-flex justify-content-center align-items-center">
                                        <div>
                                          <img src={noRecord} alt="" />
                                          <p className="mt-2 fw-bold500">No Records Found</p>
                                        </div>
                                      </div>
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                            {storyData?.length !== 0 && (
                              <div class="pagination-holder d-flex align-items-center justify-content-between">
                                <div class="d-flex align-items-center gap-2">
                                  <span class="text-muted">
                                    {" "}
                                    {start} - {end}
                                  </span>
                                  <span class="text-muted">of {totalCount}</span>

                                  <div class="pagination d-flex align-items-center gap-2">
                                    <button
                                      class={`link ${currentPage != 1 ? "" : "cursor-default"}`}
                                      aria-label="Previous"
                                      onClick={() => {
                                        if (currentPage != 1) {
                                          setPage(page - 1);
                                        }
                                      }}
                                    >
                                      <img src={backward} alt="" />
                                    </button>
                                    <button
                                      class={`link ${currentPage < noOfPage ? "" : "cursor-default"}`}
                                      aria-label="Next"
                                      onClick={() => {
                                        if (currentPage < noOfPage) {
                                          setPage(page + 1);
                                        }
                                      }}
                                    >
                                      <img src={forward} alt="" />
                                    </button>
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </PageLayout>
    </>
  );
};

const mapDispatchToProps = (dispatch) => ({
  getUserStories: (params, callback) => dispatch(getUserStories(params, callback)),
});

const mapStateToProps = (state) => ({
  userStoryData: userStoryData(state),
});

export default connect(mapStateToProps, mapDispatchToProps)(React.memo(CustomerStory));
